module.exports = __webpack_public_path__ + "img/SC-PROOF-1799.a34e3002.png";